import './EqxTile.css'
import './EqxTileGroup.css'
interface EqxTileGroupProps {
    size?: string
    children: React.ReactNode
    className?: string
}
const EqxTileGroup = function (props: EqxTileGroupProps) {
    return <div className={'tile-group row ' + (props.size ? 'svg-thumbnail-' + props.size : '') + ' ' + props.className}>{props.children}</div>
}
export default EqxTileGroup
